(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════
     Coverage Calculator — Knuckles Paints
     Scoped to section ID, prices from calcData
     ═══════════════════════════════════════════════════ */

  var FT_TO_M = 0.3048;
  var sectionId, calcData, state, screens, cur, gen;

  /* ── DOM helpers (all scoped to section) ── */

  function el(id) {
    return document.getElementById(id + '-' + sectionId);
  }

  /* ── Initialisation ── */

  function init(secId) {
    sectionId = secId;
    var json = document.getElementById('CalcData-' + sectionId);
    if (!json) return;
    calcData = JSON.parse(json.textContent);

    state = {};
    screens = [];
    cur = 0;
    gen = 0;

    var trigBtn = el('CalcTrig');
    var ovEl = el('CalcOverlay');
    var clsBtn = el('CalcClose');
    var bgEl = el('CalcBg');

    if (trigBtn) {
      trigBtn.onclick = function () {
        ovEl.classList.add('open');
        document.body.classList.add('knp-calc-open');
        document.body.style.overflow = 'hidden';
        start();
      };
    }

    function closeDr() {
      ovEl.classList.remove('open');
      document.body.classList.remove('knp-calc-open');
      document.body.style.overflow = '';
    }

    if (clsBtn) clsBtn.onclick = closeDr;
    if (bgEl) bgEl.onclick = closeDr;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ovEl.classList.contains('open')) closeDr();
    });

    /* Expose closeDr for result card ATC */
    window['knpCalcClose_' + sectionId] = closeDr;

    /* ── Back / Next buttons ── */
    var backBtn = el('CalcBack');
    var nextBtn = el('CalcNext');
    if (backBtn) backBtn.onclick = function () { goBack(); };
    if (nextBtn) nextBtn.onclick = function () { goNext(); };

    /* ── Variant awareness ── */
    document.addEventListener('product:variant-change', function (e) {
      if (e.detail && e.detail.variant) {
        calcData.product.variantId = e.detail.variant.id;
        calcData.product.price = e.detail.variant.price / 100;
      }
    });
  }

  /* ── Wizard engine ── */

  function go(i) {
    cur = i;
    gen++;
    var wiz = el('CalcWiz');
    wiz.querySelectorAll('.wiz__screen').forEach(function (s) {
      s.classList.add('exit-left');
    });
    setTimeout(function () {
      wiz.querySelectorAll('.exit-left').forEach(function (s) { s.remove(); });
    }, 400);
    var scr = document.createElement('div');
    scr.className = 'wiz__screen';
    wiz.appendChild(scr);
    screens[i].render(scr);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { scr.classList.add('active'); });
    });
    rProg();

    /* Issue 5: Use visibility:hidden instead of display:none for back button */
    el('CalcBack').style.visibility = i > 0 ? 'visible' : 'hidden';
    el('CalcBack').style.display = 'flex';

    var bar = el('CalcBar');
    if (screens[i].hideBar) {
      bar.style.display = 'none';
      el('CalcProg').style.display = 'none';
    } else if (screens[i].auto) {
      el('CalcNext').style.display = 'none';
      el('CalcBack').style.display = i > 0 ? 'flex' : 'flex';
      el('CalcBack').style.visibility = i > 0 ? 'visible' : 'hidden';
      bar.style.display = i > 0 ? '' : 'none';
      el('CalcProg').style.display = '';
    } else {
      bar.style.display = '';
      el('CalcNext').style.display = '';
      el('CalcProg').style.display = '';
      uNext();
    }
  }

  /* Issue 6: Replace dots with "Step X of Y" + fill bar */
  function rProg() {
    var p = el('CalcProg');
    var visibleScreens = screens.filter(function (s) { return !s.hideBar; });
    var visibleTotal = visibleScreens.length;
    var visibleCur = 0;
    for (var i = 0; i <= cur; i++) {
      if (!screens[i].hideBar) visibleCur++;
    }
    if (visibleCur < 1) visibleCur = 1;
    p.innerHTML =
      '<span class="prog__text">Step ' + visibleCur + ' of ' + visibleTotal + '</span>' +
      '<div class="prog__bar"><div class="prog__fill" style="width:' + ((visibleCur / visibleTotal) * 100) + '%"></div></div>';
  }

  function uNext() {
    var s = screens[cur];
    var b = el('CalcNext');
    b.disabled = !s.isValid || !s.isValid();
    b.textContent = s.nextLabel || 'Continue';
  }

  /* Issue 4: Error feedback — show error when clicking disabled Continue */
  function showError(msg) {
    var bar = el('CalcBar');
    var existing = bar.querySelector('.bar__error');
    if (existing) existing.remove();
    var errEl = document.createElement('div');
    errEl.className = 'bar__error';
    errEl.textContent = msg;
    bar.insertBefore(errEl, bar.firstChild);
    setTimeout(function () { errEl.classList.add('show'); }, 10);
    setTimeout(function () {
      errEl.classList.remove('show');
      setTimeout(function () { errEl.remove(); }, 300);
    }, 3000);
  }

  function goNext() {
    var s = screens[cur];
    if (s.isValid && !s.isValid()) {
      showError(s.errorMsg || 'Please complete this step to continue');
      return;
    }
    if (s.onNext) s.onNext();
    if (cur < screens.length - 1) go(cur + 1);
  }

  function goBack() {
    if (cur > 0) {
      gen++;
      screens = screens.slice(0, cur + 1);
      go(cur - 1);
    }
  }

  function after(ns) {
    screens = screens.slice(0, cur + 1);
    ns.forEach(function (s) { screens.push(s); });
  }

  function autoAdvance() {
    var s = screens[cur];
    if (s.onNext) s.onNext();
    var target = cur + 1;
    var g = gen;
    if (target < screens.length) {
      setTimeout(function () {
        if (gen === g) go(target);
      }, 300);
    }
  }

  function bindOpts(c, cb, autoAdv) {
    c.querySelectorAll('.opt').forEach(function (o) {
      o.onclick = function () {
        c.querySelectorAll('.opt').forEach(function (x) { x.classList.remove('on'); });
        o.classList.add('on');
        cb(o.dataset.v);
        if (autoAdv) autoAdvance();
      };
    });
  }

  /* ── Cart integration ── */

  function addToCart(items) {
    /* Tag calculator-driven adds with hidden line item
       properties for order tracking. Underscore-prefixed
       property names are hidden from customers but visible
       to admin and in order exports. */
    var flow = calcData && calcData.productType ? calcData.productType : 'unknown';
    items.forEach(function (item, idx) {
      item.properties = item.properties || {};
      item.properties['_Source'] = 'coverage_calculator';
      item.properties['_Calc_flow'] = flow;
      item.properties['_Calc_recommended_qty'] = String(item.quantity);
      item.properties['_Calc_role'] = (idx === 0) ? 'paint' : 'primer';
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    }).then(function (response) {
      /* Close the calculator drawer */
      var closeFn = window['knpCalcClose_' + sectionId];
      if (closeFn) closeFn();

      /* Refresh cart drawer HTML */
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      /* Open the cart drawer — exact same pattern as theme's own ATC in app.js */
      var cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
      }

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      }
    }).catch(function (err) {
      console.error('Coverage Calculator ATC error:', err);
    });
  }

  /* ── Product image helper ── */

  function prodImg(src, alt) {
    if (src) {
      return '<div class="prod__img"><img src="' + src + '" alt="' + alt + '" loading="lazy"></div>';
    }
    return '<div class="prod__img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="1" width="18" height="22" rx="2"/></svg></div>';
  }

  function primerImg(src, alt) {
    if (src) {
      return '<div class="prod__img"><img src="' + src + '" alt="' + alt + '" loading="lazy"></div>';
    }
    return '<div class="prod__img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="1" width="18" height="22" rx="2"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/></svg></div>';
  }

  /* ── Checkmark SVG ── */

  var checkSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="var(--green)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var tickWhiteSvg = '<svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ── Back arrow SVG ── */

  var backSvg = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M10 3L5 8l5 5"/></svg>';

  /* ── Hint SVG ── */

  var hintSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="var(--muted)" stroke-width="1.5"><circle cx="8" cy="8" r="7"/><line x1="8" y1="7" x2="8" y2="11"/><circle cx="8" cy="5" r="0.5" fill="var(--muted)"/></svg>';

  /* ═══════════════════════════════════════════════════
     START — reads calcData.productType, skips Q1
     ═══════════════════════════════════════════════════ */

  function start() {
    state = {};
    var t = calcData.productType;

    if (t === 'door') {
      state.type = 'door';
      screens = [
        { id: 'd1', render: rDType, auto: true, isValid: function () { return !!state.dType; } },
        { id: 'd2', render: rDCoats, auto: true, isValid: function () { return !!state.dCoats; } },
        { id: 'd3', render: rDPrimer, auto: true, isValid: function () { return state._dP !== undefined; } },
        { id: 'd4', render: rDRes, hideBar: true, isValid: function () { return true; } }
      ];
    } else if (t === 'interior') {
      /* Issue 2: Remove rIUnit as a separate step — default to metres */
      state.type = 'interior';
      state.iU = 'm';
      state.iHt = 2.4;
      screens = [
        { id: 'i1', render: rIHeight, isValid: function () { return true; } },
        { id: 'i2', render: rIWalls, isValid: function () { return state.iW && state.iW.length > 0; }, errorMsg: 'Add at least one wall to continue' },
        {
          id: 'i3', render: rIOpts, isValid: function () { return true; }, nextLabel: 'Calculate',
          onNext: function () {
            after([{ id: 'i4', render: rIRes, hideBar: true, isValid: function () { return true; } }]);
          }
        },
        { id: 'i4', render: rIRes, hideBar: true, isValid: function () { return true; } }
      ];
    } else if (t === 'masonry') {
      state.type = 'masonry';
      screens = [
        {
          id: 'm1', render: rMSurf, auto: true, isValid: function () { return !!state.mSurf; },
          onNext: function () {
            after([
              {
                id: 'mW', render: rMWhat, auto: true, isValid: function () { return !!state.mWhat; },
                onNext: function () {
                  /* Build the rest of flow based on what they're painting */
                  var calcFlow;
                  if (state.mWhat === 'building') {
                    calcFlow = [
                      {
                        id: 'm3', render: rMMethod, auto: true, isValid: function () { return !!state.mMethod; },
                        onNext: function () {
                          if (state.mMethod === 'estimate') {
                            after([
                              { id: 'm3b', render: rMBare, auto: true, isValid: function () { return state.mBare !== undefined; } },
                              {
                                id: 'm4', render: rMHouse, isValid: function () { return !!state.mHouse; }, nextLabel: 'Calculate',
                                errorMsg: 'Select a property type',
                                onNext: function () { after([{ id: 'm5', render: rMRes, hideBar: true, isValid: function () { return true; } }]); }
                              },
                              { id: 'm5', render: rMRes, hideBar: true, isValid: function () { return true; } }
                            ]);
                          } else {
                            after([
                              { id: 'm3b', render: rMBare, auto: true, isValid: function () { return state.mBare !== undefined; } },
                              {
                                id: 'm4', render: rMWalls, isValid: function () { return state.mW && state.mW.length > 0; }, nextLabel: 'Calculate',
                                errorMsg: 'Add at least one wall to continue',
                                onNext: function () { after([{ id: 'm5', render: rMRes, hideBar: true, isValid: function () { return true; } }]); }
                              },
                              { id: 'm5', render: rMRes, hideBar: true, isValid: function () { return true; } }
                            ]);
                          }
                        }
                      }
                    ];
                  } else {
                    /* Wall or structure — bare question then straight to measurements */
                    calcFlow = [
                      { id: 'm3b', render: rMBare, auto: true, isValid: function () { return state.mBare !== undefined; } },
                      {
                        id: 'm3', render: rMWalls, isValid: function () { return state.mW && state.mW.length > 0; }, nextLabel: 'Calculate',
                        errorMsg: 'Add at least one wall to continue',
                        onNext: function () { after([{ id: 'm4', render: rMRes, hideBar: true, isValid: function () { return true; } }]); }
                      },
                      { id: 'm4', render: rMRes, hideBar: true, isValid: function () { return true; } }
                    ];
                  }
                  after(calcFlow);
                }
              }
            ]);
          }
        }
      ];
    }

    cur = 0;
    gen++;
    go(0);
  }

  /* ═══════════════════════════════════════════════════
     DOOR FLOW
     ═══════════════════════════════════════════════════ */

  function rDType(scr) {
    scr.innerHTML =
      '<p class="q">What type of door?</p>' +
      '<p class="q-sub">Select the closest match.</p>' +
      '<div class="opts opts--grid3">' +
        '<div class="opt opt--icon" data-v="single">' +
          '<svg class="opt__ico" viewBox="0 0 36 56" fill="none" stroke="currentColor" stroke-width=".75"><rect x="2" y="1" width="32" height="54" rx="1.5"/><circle cx="28" cy="28" r="1.5"/><line x1="2" y1="16" x2="34" y2="16" stroke-dasharray="1.5 1.5"/></svg>' +
          '<span class="opt__title">Single</span><span class="opt__desc">~2.2m\u00b2</span>' +
        '</div>' +
        '<div class="opt opt--icon" data-v="double">' +
          '<svg class="opt__ico" viewBox="0 0 36 56" fill="none" stroke="currentColor" stroke-width=".75"><rect x="1" y="1" width="16" height="54" rx="1.5"/><rect x="19" y="1" width="16" height="54" rx="1.5"/><circle cx="14" cy="28" r="1.2"/><circle cx="22" cy="28" r="1.2"/></svg>' +
          '<span class="opt__title">Double</span><span class="opt__desc">~3.2m\u00b2</span>' +
        '</div>' +
      '</div>';
    bindOpts(scr, function (v) { state.dType = v; uNext(); }, true);
  }

  function rDCoats(scr) {
    scr.innerHTML =
      '<p class="q">How big a colour change?</p>' +
      '<p class="q-sub">Bigger changes need more coats for full coverage.</p>' +
      '<div class="opts">' +
        '<div class="opt" data-v="2"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Similar shade</span><span class="opt__desc">2 coats -- light refresh or similar colour</span></div></div>' +
        '<div class="opt" data-v="3"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Bold change</span><span class="opt__desc">3 coats -- dark to light, or major colour change</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state.dCoats = parseInt(v); uNext(); }, true);
  }

  function rDPrimer(scr) {
    var primerPrice = calcData.primer.available ? '\u00a3' + calcData.primer.price.toFixed(0) : '\u00a329';
    scr.innerHTML =
      '<p class="q">Would you like to add primer?</p>' +
      '<p class="q-sub">We recommend primer for the best finish on doors.</p>' +
      '<div class="primer-usp">' +
        '<div class="primer-usp__row">' + checkSvg + '<span>Improves adhesion and longevity of topcoat</span></div>' +
        '<div class="primer-usp__row">' + checkSvg + '<span>Blocks stains and tannin bleed on bare wood</span></div>' +
        '<div class="primer-usp__row">' + checkSvg + '<span>Essential for bold colour changes or dark-to-light</span></div>' +
        '<div class="primer-usp__row">' + checkSvg + '<span>Gives a smoother, more professional finish</span></div>' +
      '</div>' +
      '<div class="opts">' +
        '<div class="opt" data-v="yes"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Yes, add primer <span class="primer-row__pill">Recommended</span></span><span class="opt__desc">' + primerPrice + ' per 750ml tin</span></div></div>' +
        '<div class="opt" data-v="no"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">No thanks</span><span class="opt__desc">I\'ll skip primer for now</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state._dP = v === 'yes'; uNext(); }, true);
  }

  /* Issue 1: Result screen "Start over" button calls start() instead of goBack() */
  function rDRes(scr) {
    var A = { single: 2.2, double: 3.2 };
    var a = A[state.dType];
    var tins = 1;
    if (state.dType === 'double' && state.dCoats === 3) tins = 2;
    state._dT = tins;

    var paintPrice = calcData.product.price;
    var paintTotal = (tins * paintPrice).toFixed(2);

    var primerRow = '';
    var primerCost = 0;
    if (state._dP && calcData.primer.available) {
      primerCost = tins * calcData.primer.price;
      primerRow =
        '<div class="prod">' +
          primerImg(calcData.primer.image, calcData.primer.title) +
          '<div class="prod__body"><span class="prod__name">' + calcData.primer.title + '</span><span class="prod__meta">750ml \u00b7 ' + tins + (tins === 1 ? ' tin' : ' tins') + '</span></div>' +
          '<span class="prod__price">\u00a3' + primerCost.toFixed(2) + '</span>' +
        '</div>';
    }

    var total = tins * paintPrice + primerCost;

    scr.innerHTML =
      '<div class="res__card">' +
        '<p class="res__hl">Your order*</p>' +
        '<p class="res__det">Based on a ' + state.dType + ' door (' + a.toFixed(1) + 'm\u00b2) with ' + state.dCoats + ' coats.</p>' +
        '<div class="prod">' +
          prodImg(calcData.product.image, calcData.product.title) +
          '<div class="prod__body"><span class="prod__name">' + calcData.product.title + '</span><span class="prod__meta">750ml \u00b7 ' + tins + (tins === 1 ? ' tin' : ' tins') + '</span></div>' +
          '<span class="prod__price">\u00a3' + paintTotal + '</span>' +
        '</div>' +
        primerRow +
        '<div class="res__brk">' + state.dType + ' door with ' + state.dCoats + ' coats. Each 750ml tin covers one front door at 2 coats.</div>' +
        '<button class="res__cta" id="CalcAtc-' + sectionId + '">Add to basket \u00b7 \u00a3' + total.toFixed(2) + '</button>' +
        '<p class="res__note">*This is an estimate. Actual coverage varies with surface, application method, and colour change.</p>' +
      '</div>' +
      '<button class="bar__back" id="CalcResBack-' + sectionId + '" style="margin-top:14px">' + backSvg + 'Start over</button>';

    el('CalcAtc').onclick = function () {
      var items = [{ id: calcData.product.variantId, quantity: tins }];
      if (state._dP && calcData.primer.available) {
        items.push({ id: calcData.primer.variantId, quantity: tins });
      }
      addToCart(items);
    };
    el('CalcResBack').onclick = function () { start(); };
  }

  /* ═══════════════════════════════════════════════════
     INTERIOR FLOW
     ═══════════════════════════════════════════════════ */

  /* Issue 2: Redesigned ceiling height screen with unit toggle + property type cards */
  function rIHeight(scr) {
    if (!state.iHt) state.iHt = state.iU === 'ft' ? 7.9 : 2.4;
    if (!state.iHtType) state.iHtType = 'standard';
    var u = state.iU === 'ft' ? 'ft' : 'm';
    var stdH = state.iU === 'ft' ? 7.9 : 2.4;
    var periodH = state.iU === 'ft' ? 10.5 : 3.2;
    var stdLabel = state.iU === 'ft' ? '~7.9ft' : '~2.4m';
    var periodLabel = state.iU === 'ft' ? '~10.5ft' : '~3.2m';

    scr.innerHTML =
      '<p class="q">What\'s your ceiling height?</p>' +
      '<p class="q-sub">Most UK homes built after 1950 have standard heights. Fine-tune with +/- if needed.</p>' +
      '<div class="meas-row">' +
        '<span class="meas-row__label">Measuring in</span>' +
        '<div class="unit-tog" id="CalcIUT-' + sectionId + '">' +
          '<button class="unit-tog__btn' + (state.iU === 'm' ? ' on' : '') + '" data-u="m">Metres</button>' +
          '<button class="unit-tog__btn' + (state.iU === 'ft' ? ' on' : '') + '" data-u="ft">Feet</button>' +
        '</div>' +
      '</div>' +
      '<div class="height-hero">' +
        '<div class="height-hero__controls">' +
          '<button class="height-hero__btn" id="CalcHMinus-' + sectionId + '">\u2212</button>' +
          '<div class="height-hero__value">' +
            '<div class="height-hero__num" id="CalcHV-' + sectionId + '">' + state.iHt + '</div>' +
            '<div class="height-hero__unit" id="CalcHU-' + sectionId + '">' + (u === 'm' ? 'metres' : 'feet') + '</div>' +
          '</div>' +
          '<button class="height-hero__btn" id="CalcHPlus-' + sectionId + '">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="opts opts--row" id="CalcHType-' + sectionId + '">' +
        '<div class="opt opt--compact' + (state.iHtType === 'standard' ? ' on' : '') + '" data-v="standard" style="flex:1">' +
          '<div class="opt__radio"></div>' +
          '<div class="opt__body"><span class="opt__title">Standard</span><span class="opt__desc">' + stdLabel + '</span></div>' +
        '</div>' +
        '<div class="opt opt--compact' + (state.iHtType === 'period' ? ' on' : '') + '" data-v="period" style="flex:1">' +
          '<div class="opt__radio"></div>' +
          '<div class="opt__body"><span class="opt__title">Period property</span><span class="opt__desc">' + periodLabel + '</span></div>' +
        '</div>' +
      '</div>';

    /* Wire up +/- buttons */
    el('CalcHMinus').onclick = function () { sIH(-1); };
    el('CalcHPlus').onclick = function () { sIH(1); };

    /* Wire up property type selector */
    bindOpts(el('CalcHType'), function (v) {
      state.iHtType = v;
      state.iHt = v === 'period' ? periodH : stdH;
      el('CalcHV').textContent = state.iHt;
    });

    /* Wire up unit toggle */
    el('CalcIUT').querySelectorAll('.unit-tog__btn').forEach(function (b) {
      b.onclick = function () {
        state.iU = b.dataset.u;
        el('CalcIUT').querySelectorAll('.unit-tog__btn').forEach(function (x) {
          x.classList.toggle('on', x.dataset.u === state.iU);
        });
        /* Convert current height */
        if (state.iU === 'ft') {
          state.iHt = Math.round(state.iHt / FT_TO_M * 10) / 10;
        } else {
          state.iHt = Math.round(state.iHt * FT_TO_M * 10) / 10;
        }
        el('CalcHV').textContent = state.iHt;
        el('CalcHU').textContent = state.iU === 'm' ? 'metres' : 'feet';
        /* Re-render the type selector labels */
        rIHeight(scr);
      };
    });
  }

  function sIH(d) {
    var s = state.iU === 'ft' ? 0.5 : 0.1;
    state.iHt = Math.max(0.5, Math.round((state.iHt + d * s) * 10) / 10);
    el('CalcHV').textContent = state.iHt;
  }

  function sIHSet(v) {
    state.iHt = v;
    el('CalcHV').textContent = state.iHt;
  }

  /* ── Interior: Add walls ── */

  function iWDefault() { return state.iU === 'ft' ? 10 : 3; }

  /* Issue 3: Wall adder UX — instructive subtitle, secondary add wall button, hint */
  function rIWalls(scr) {
    if (!state.iW) state.iW = [];
    state._iC = iWDefault();
    var u = state.iU === 'ft' ? 'ft' : 'm';

    var hintHtml = '';
    if (state.iW.length === 0) {
      hintHtml =
        '<div class="hint" id="CalcHint-' + sectionId + '">' +
          hintSvg +
          '<span>Edit the measurements below, then tap \'Add wall\'</span>' +
        '</div>';
    }

    scr.innerHTML =
      '<p class="q">Add your walls</p>' +
      '<p class="q-sub">Enter the width of each wall and tap \'Add wall\'. Add all walls before continuing.</p>' +
      '<div class="chips" id="CalcICh-' + sectionId + '"></div>' +
      hintHtml +
      '<div class="wall-card">' +
        '<div class="wall-card__title" id="CalcIWL-' + sectionId + '">Wall ' + (state.iW.length + 1) + '</div>' +
        '<div class="wall-card__row">' +
          '<span class="wall-card__label">Width</span>' +
          '<div class="stp">' +
            '<button class="stp__btn" id="CalcIWMinus-' + sectionId + '">\u2212</button>' +
            '<input class="stp__in" id="CalcIWV-' + sectionId + '" type="number" value="' + state._iC + '" step="0.1" min="0" inputmode="decimal">' +
            '<button class="stp__btn" id="CalcIWPlus-' + sectionId + '">+</button>' +
          '</div>' +
          '<span class="wall-card__unit">' + u + '</span>' +
        '</div>' +
        '<button class="wadd__btn" id="CalcIWAdd-' + sectionId + '" style="width:100%;margin-top:16px">\uff0b Add wall</button>' +
      '</div>';

    el('CalcIWMinus').onclick = function () { sIW(-1); };
    el('CalcIWPlus').onclick = function () { sIW(1); };
    el('CalcIWV').onchange = function () { state._iC = Math.max(0, parseFloat(this.value) || 0); };
    el('CalcIWAdd').onclick = function () { aIW(); };
    rICh();
  }

  function sIW(d) {
    var s = state.iU === 'ft' ? 1 : 0.5;
    state._iC = Math.max(0, Math.round(((state._iC || 0) + d * s) * 10) / 10);
    el('CalcIWV').value = state._iC;
  }

  function aIW() {
    if (!state._iC || state._iC <= 0) return;
    state.iW.push({ v: state._iC, u: state.iU === 'ft' ? 'ft' : 'm' });
    state._iC = iWDefault();
    el('CalcIWV').value = state._iC;
    /* Hide the hint after first wall is added */
    var hint = el('CalcHint');
    if (hint) hint.style.display = 'none';
    rICh();
    uNext();
  }

  function rICh() {
    var c = el('CalcICh');
    if (!c) return;
    c.innerHTML = '';
    state.iW.forEach(function (w, i) {
      var h = document.createElement('span');
      h.className = 'chip';
      h.innerHTML =
        '<span style="color:var(--light);font-weight:400">Wall ' + (i + 1) + '</span>' +
        '<span style="width:1px;height:14px;background:var(--border);flex-shrink:0"></span>' +
        '<span style="font-weight:600">' + w.v + w.u + '</span> ' +
        '<button class="chip__x" data-idx="' + i + '">\u00d7</button>';
      c.appendChild(h);
    });
    c.onclick = function (e) {
      var btn = e.target.closest('.chip__x');
      if (btn) xIW(parseInt(btn.dataset.idx));
    };
    var l = el('CalcIWL');
    if (l) l.textContent = 'Wall ' + (state.iW.length + 1);
  }

  function xIW(i) { state.iW.splice(i, 1); rICh(); uNext(); }

  /* ── Interior: Adjustments ── */

  function rIOpts(scr) {
    if (state.iD === undefined) state.iD = 1;
    if (state.iWn === undefined) state.iWn = 1;
    if (state.iCl === undefined) state.iCl = false;

    scr.innerHTML =
      '<p class="q">Any adjustments?</p>' +
      '<p class="q-sub">We\'ll subtract doors and windows from the total area.</p>' +
      '<div class="trow">' +
        '<div><div class="trow__lbl">Include ceiling</div><div class="trow__sub">Estimated from room footprint</div></div>' +
        '<div class="sw' + (state.iCl ? ' on' : '') + '" id="CalcSwC-' + sectionId + '"><div class="sw__k"></div></div>' +
      '</div>' +
      '<div class="srow">' +
        '<div class="srow__label">Doors to subtract</div>' +
        '<div class="stp">' +
          '<button class="stp__btn" id="CalcIDMinus-' + sectionId + '">\u2212</button>' +
          '<div class="stp__v" id="CalcIDV-' + sectionId + '">' + state.iD + '</div>' +
          '<button class="stp__btn" id="CalcIDPlus-' + sectionId + '">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="srow">' +
        '<div class="srow__label">Windows to subtract</div>' +
        '<div class="stp">' +
          '<button class="stp__btn" id="CalcIWnMinus-' + sectionId + '">\u2212</button>' +
          '<div class="stp__v" id="CalcIWnV-' + sectionId + '">' + state.iWn + '</div>' +
          '<button class="stp__btn" id="CalcIWnPlus-' + sectionId + '">+</button>' +
        '</div>' +
      '</div>';

    el('CalcSwC').onclick = function () {
      state.iCl = !state.iCl;
      this.classList.toggle('on', state.iCl);
    };
    el('CalcIDMinus').onclick = function () { sIC('iD', -1); };
    el('CalcIDPlus').onclick = function () { sIC('iD', 1); };
    el('CalcIWnMinus').onclick = function () { sIC('iWn', -1); };
    el('CalcIWnPlus').onclick = function () { sIC('iWn', 1); };
  }

  function sIC(k, d) {
    state[k] = Math.max(0, (state[k] || 0) + d);
    var elId = k === 'iD' ? 'CalcIDV' : 'CalcIWnV';
    el(elId).textContent = state[k];
  }

  /* ── Interior: Result ── */
  /* Issue 1: "Start over" calls start() */

  function rIRes(scr) {
    var hm = state.iU === 'ft' ? state.iHt * FT_TO_M : state.iHt;
    var wa = 0;
    var ws = [];
    state.iW.forEach(function (w) {
      var m = w.u === 'ft' ? w.v * FT_TO_M : w.v;
      wa += m * hm;
      ws.push(m);
    });
    wa -= (state.iD * 1.9) + (state.iWn * 1.4);
    if (wa < 0) wa = 0;
    var ca = 0;
    if (state.iCl && ws.length >= 2) ca = ws[0] * ws[1];
    var tot = wa + ca;
    var wc = tot * 2;
    var tins = Math.ceil(wc / 35);
    if (tins < 1 && tot > 0) tins = 1;
    state._iT = tins;

    var paintPrice = calcData.product.price;
    var paintTotal = (tins * paintPrice).toFixed(2);

    scr.innerHTML =
      '<div class="res__card">' +
        '<p class="res__hl">You\'ll need ' + tins + (tins === 1 ? ' tin' : ' tins') + '*</p>' +
        '<p class="res__det">' + tot.toFixed(1) + 'm\u00b2 total with 2 coats.' + (ca > 0 ? ' Includes ceiling (' + ca.toFixed(1) + 'm\u00b2).' : '') + '</p>' +
        '<div class="prod">' +
          prodImg(calcData.product.image, calcData.product.title) +
          '<div class="prod__body"><span class="prod__name">' + calcData.product.title + '</span><span class="prod__meta">2.5L \u00b7 ' + tins + (tins === 1 ? ' tin' : ' tins') + '</span></div>' +
          '<span class="prod__price">\u00a3' + paintTotal + '</span>' +
        '</div>' +
        '<div class="res__brk">Walls: ' + wa.toFixed(1) + 'm\u00b2' + (ca > 0 ? ' + Ceiling: ' + ca.toFixed(1) + 'm\u00b2' : '') + ' = ' + tot.toFixed(1) + 'm\u00b2 \u00d7 2 coats = ' + wc.toFixed(1) + 'm\u00b2. Each 2.5L covers ~35m\u00b2.</div>' +
        '<button class="res__cta" id="CalcAtc-' + sectionId + '">Add to basket \u00b7 \u00a3' + paintTotal + '</button>' +
        '<p class="res__note">*This is an estimate. Actual coverage varies with surface, application method, and colour change.</p>' +
      '</div>' +
      '<button class="bar__back" id="CalcResBack-' + sectionId + '" style="margin-top:14px">' + backSvg + 'Start over</button>';

    el('CalcAtc').onclick = function () {
      var items = [{ id: calcData.product.variantId, quantity: tins }];
      addToCart(items);
    };
    el('CalcResBack').onclick = function () { start(); };
  }

  /* ═══════════════════════════════════════════════════
     MASONRY FLOW
     ═══════════════════════════════════════════════════ */

  function rMSurf(scr) {
    scr.innerHTML =
      '<p class="q">What\'s the surface like?</p>' +
      '<p class="q-sub">This affects how much paint the surface absorbs.</p>' +
      '<div class="opts">' +
        '<div class="opt" data-v="smooth"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Smooth</span><span class="opt__desc">Render, painted brick, smooth block</span></div></div>' +
        '<div class="opt" data-v="rough"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Rough / Textured</span><span class="opt__desc">Pebbledash, exposed brick, roughcast</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state.mSurf = v; uNext(); }, true);
  }

  function rMBare(scr) {
    scr.innerHTML =
      '<p class="q">Has it been painted before?</p>' +
      '<p class="q-sub">Bare or unpainted surfaces need a stabilising primer for the best result.</p>' +
      '<div class="opts">' +
        '<div class="opt" data-v="no"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Yes, it\'s been painted</span><span class="opt__desc">Existing paint in reasonable condition</span></div></div>' +
        '<div class="opt" data-v="yes"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">No, it\'s bare</span><span class="opt__desc">New render, exposed brick, concrete, or unpainted</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state.mBare = (v === 'yes'); uNext(); }, true);
  }

  function rMWhat(scr) {
    scr.innerHTML =
      '<p class="q">What are you painting?</p>' +
      '<p class="q-sub">This helps us estimate the area.</p>' +
      '<div class="opts">' +
        '<div class="opt" data-v="building"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Building exterior</span><span class="opt__desc">Home, venue, or commercial property</span></div></div>' +
        '<div class="opt" data-v="wall"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Wall or structure</span><span class="opt__desc">Garden wall, garage, boundary wall</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state.mWhat = v; uNext(); }, true);
  }

  function rMMethod(scr) {
    scr.innerHTML =
      '<p class="q">How would you like to calculate?</p>' +
      '<p class="q-sub">Choose a quick estimate or enter exact measurements.</p>' +
      '<div class="opts">' +
        '<div class="opt" data-v="estimate"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Quick estimate</span><span class="opt__desc">Based on property type</span></div></div>' +
        '<div class="opt" data-v="exact"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Exact measurements</span><span class="opt__desc">I have the dimensions</span></div></div>' +
      '</div>';
    bindOpts(scr, function (v) { state.mMethod = v; uNext(); }, true);
  }

  function rMHouse(scr) {
    if (!state.mScope) state.mScope = 'front';
    scr.innerHTML =
      '<p class="q">Property type & scope</p>' +
      '<p class="q-sub">Select your property and what you\'re painting.</p>' +
      '<div class="opts opts--grid3" id="CalcMHO-' + sectionId + '">' +
        '<div class="opt opt--icon" data-v="terrace">' +
          '<svg class="opt__ico" viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="43" x2="56" y2="43"/><path d="M6 43V18L15 9l9 9v-9l9-9 9 9v25"/></svg>' +
          '<span class="opt__title">Terrace</span><span class="opt__desc">~40m\u00b2</span>' +
        '</div>' +
        '<div class="opt opt--icon" data-v="semi">' +
          '<svg class="opt__ico" viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="43" x2="56" y2="43"/><path d="M8 43V16L28 4l20 12v27H8z"/></svg>' +
          '<span class="opt__title">Semi</span><span class="opt__desc">~90m\u00b2</span>' +
        '</div>' +
        '<div class="opt opt--icon" data-v="detached">' +
          '<svg class="opt__ico" viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="43" x2="56" y2="43"/><path d="M4 43V16L28 2l24 14v27H4z"/></svg>' +
          '<span class="opt__title">Detached</span><span class="opt__desc">~120m\u00b2</span>' +
        '</div>' +
      '</div>' +
      '<div style="margin-top:16px">' +
        '<div class="opts" style="flex-direction:row;gap:10px" id="CalcMSO-' + sectionId + '">' +
          '<div class="opt on" data-v="front" style="flex:1"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Front only</span></div></div>' +
          '<div class="opt" data-v="full" style="flex:1"><div class="opt__radio"></div><div class="opt__body"><span class="opt__title">Full exterior</span></div></div>' +
        '</div>' +
      '</div>';
    bindOpts(el('CalcMHO'), function (v) { state.mHouse = v; uNext(); });
    bindOpts(el('CalcMSO'), function (v) { state.mScope = v; });
  }

  /* ── Masonry: Wall measurements ── */
  /* Issue 3: Wall adder UX — instructive subtitle, secondary add wall button, hint */

  function mWDefaults() { return state.mU === 'ft' ? { w: 10, h: 8 } : { w: 3, h: 2.5 }; }

  function rMWalls(scr) {
    if (!state.mU) state.mU = 'm';
    if (!state.mW) state.mW = [];
    var defs = mWDefaults();
    state._mC = { w: defs.w, h: defs.h };
    var u = state.mU === 'ft' ? 'ft' : 'm';

    var hintHtml = '';
    if (state.mW.length === 0) {
      hintHtml =
        '<div class="hint" id="CalcMHint-' + sectionId + '">' +
          hintSvg +
          '<span>Edit the measurements below, then tap \'Add wall\'</span>' +
        '</div>';
    }

    scr.innerHTML =
      '<p class="q">Wall measurements</p>' +
      '<p class="q-sub">Enter the width and height of each wall and tap \'Add wall\'. Add all walls before continuing.</p>' +
      '<div class="meas-row">' +
        '<span class="meas-row__label">Measuring in</span>' +
        '<div class="unit-tog" id="CalcMUT-' + sectionId + '">' +
          '<button class="unit-tog__btn' + (state.mU === 'm' ? ' on' : '') + '" data-u="m">Metres</button>' +
          '<button class="unit-tog__btn' + (state.mU === 'ft' ? ' on' : '') + '" data-u="ft">Feet</button>' +
        '</div>' +
      '</div>' +
      '<div class="chips" id="CalcMCh-' + sectionId + '"></div>' +
      hintHtml +
      '<div class="wall-card">' +
        '<div class="wall-card__title" id="CalcMWL-' + sectionId + '">Wall ' + (state.mW.length + 1) + '</div>' +
        '<div class="wall-card__row" style="border-top:none">' +
          '<span class="wall-card__label">Width</span>' +
          '<div class="stp">' +
            '<button class="stp__btn" id="CalcMWMinus-' + sectionId + '">\u2212</button>' +
            '<input class="stp__in" id="CalcMWV-' + sectionId + '" type="number" value="' + defs.w + '" step="0.1" min="0" inputmode="decimal">' +
            '<button class="stp__btn" id="CalcMWPlus-' + sectionId + '">+</button>' +
          '</div>' +
          '<span class="wall-card__unit--sm" id="CalcMU1-' + sectionId + '">' + u + '</span>' +
        '</div>' +
        '<div class="wall-card__row">' +
          '<span class="wall-card__label">Height</span>' +
          '<div class="stp">' +
            '<button class="stp__btn" id="CalcMHMinus-' + sectionId + '">\u2212</button>' +
            '<input class="stp__in" id="CalcMHV-' + sectionId + '" type="number" value="' + defs.h + '" step="0.1" min="0" inputmode="decimal">' +
            '<button class="stp__btn" id="CalcMHPlus-' + sectionId + '">+</button>' +
          '</div>' +
          '<span class="wall-card__unit--sm" id="CalcMU2-' + sectionId + '">' + u + '</span>' +
        '</div>' +
        '<button class="wadd__btn" id="CalcMWAdd-' + sectionId + '" style="width:100%;margin-top:16px">\uff0b Add wall</button>' +
      '</div>';

    el('CalcMWMinus').onclick = function () { sMW('w', -1); };
    el('CalcMWPlus').onclick = function () { sMW('w', 1); };
    el('CalcMHMinus').onclick = function () { sMW('h', -1); };
    el('CalcMHPlus').onclick = function () { sMW('h', 1); };
    el('CalcMWV').onchange = function () { state._mC.w = Math.max(0, parseFloat(this.value) || 0); };
    el('CalcMHV').onchange = function () { state._mC.h = Math.max(0, parseFloat(this.value) || 0); };
    el('CalcMWAdd').onclick = function () { aMW(); };

    el('CalcMUT').querySelectorAll('.unit-tog__btn').forEach(function (b) {
      b.onclick = function () {
        state.mU = b.dataset.u;
        el('CalcMUT').querySelectorAll('.unit-tog__btn').forEach(function (x) {
          x.classList.toggle('on', x.dataset.u === state.mU);
        });
        var u2 = state.mU === 'ft' ? 'ft' : 'm';
        el('CalcMU1').textContent = u2;
        el('CalcMU2').textContent = u2;
        var d = mWDefaults();
        state._mC = { w: d.w, h: d.h };
        el('CalcMWV').value = d.w;
        el('CalcMHV').value = d.h;
      };
    });

    rMCh();
  }

  function sMW(dim, dir) {
    var s = state.mU === 'ft' ? 1 : 0.5;
    state._mC[dim] = Math.max(0, Math.round((state._mC[dim] + dir * s) * 10) / 10);
    el(dim === 'w' ? 'CalcMWV' : 'CalcMHV').value = state._mC[dim];
  }

  function aMW() {
    if (state._mC.w <= 0 || state._mC.h <= 0) return;
    state.mW.push({ w: state._mC.w, h: state._mC.h, u: state.mU === 'ft' ? 'ft' : 'm' });
    var d = mWDefaults();
    state._mC = { w: d.w, h: d.h };
    el('CalcMWV').value = d.w;
    el('CalcMHV').value = d.h;
    /* Hide the hint after first wall is added */
    var hint = el('CalcMHint');
    if (hint) hint.style.display = 'none';
    rMCh();
    uNext();
  }

  function rMCh() {
    var c = el('CalcMCh');
    if (!c) return;
    c.innerHTML = '';
    state.mW.forEach(function (w, i) {
      var h = document.createElement('span');
      h.className = 'chip';
      h.innerHTML =
        '<span style="color:var(--light);font-weight:400">Wall ' + (i + 1) + '</span>' +
        '<span style="width:1px;height:14px;background:var(--border);flex-shrink:0"></span>' +
        '<span style="font-weight:600">' + w.w + '\u00d7' + w.h + w.u + '</span> ' +
        '<button class="chip__x" data-idx="' + i + '">\u00d7</button>';
      c.appendChild(h);
    });
    c.onclick = function (e) {
      var btn = e.target.closest('.chip__x');
      if (btn) xMW(parseInt(btn.dataset.idx));
    };
    var l = el('CalcMWL');
    if (l) l.textContent = 'Wall ' + (state.mW.length + 1);
  }

  function xMW(i) { state.mW.splice(i, 1); rMCh(); uNext(); }

  /* ── Masonry: Result ── */
  /* Issue 1: "Start over" calls start() */
  /* Issue 7: 2.5L small job note */

  function rMRes(scr) {
    var estTins = {
      smooth: { terrace: { front: 2, full: 4 }, semi: { front: 4, full: 8 }, detached: { front: 5, full: 10 } },
      rough: { terrace: { front: 4, full: 8 }, semi: { front: 8, full: 16 }, detached: { front: 12, full: 24 } }
    };
    var estAreas = {
      terrace: { front: 20, full: 40 },
      semi: { front: 45, full: 90 },
      detached: { front: 50, full: 120 }
    };
    var mPerTin = { smooth: 12, rough: 5 };
    var area = 0, desc = '', tins = 0;
    var sl = state.mSurf === 'smooth' ? 'smooth' : 'rough/textured';

    if (state.mWhat === 'building' && state.mMethod === 'estimate') {
      tins = estTins[state.mSurf][state.mHouse][state.mScope];
      area = estAreas[state.mHouse][state.mScope];
      var hl = state.mHouse === 'terrace' ? 'terraced house' : state.mHouse === 'semi' ? 'semi-detached' : 'detached house';
      desc = 'Based on a ' + hl + ' ' + (state.mScope === 'front' ? 'front elevation' : 'full exterior') + ' (~' + area + 'm\u00b2)';
    } else {
      (state.mW || []).forEach(function (w) {
        var wm = w.u === 'ft' ? w.w * FT_TO_M : w.w;
        var hm = w.u === 'ft' ? w.h * FT_TO_M : w.h;
        area += wm * hm;
      });
      if (area < 0) area = 0;
      tins = Math.ceil(area / mPerTin[state.mSurf]);
      desc = 'Based on your measurements (' + area.toFixed(1) + 'm\u00b2)';
    }
    if (tins < 1 && area > 0) tins = 1;
    state._mT = tins;

    var tinSize = '5L';
    var isSmallJob = false;
    var paintPrice = calcData.product.price;
    if (tins <= 1 && area <= 12) { tinSize = '2.5L'; tins = 1; isSmallJob = true; }

    var paintTotal = (tins * paintPrice).toFixed(2);

    var primerRow = '';
    var primerCost = 0;
    if (state.mBare && calcData.primer.available) {
      primerCost = tins * calcData.primer.price;
      primerRow =
        '<div class="prod">' +
          primerImg(calcData.primer.image, calcData.primer.title) +
          '<div class="prod__body">' +
            '<span class="prod__name">' + calcData.primer.title + '</span>' +
            '<span class="prod__meta">' + tinSize + ' \u00b7 ' + tins + (tins === 1 ? ' tin' : ' tins') + '</span>' +
            '<span class="primer-row__pill">Required for bare masonry</span>' +
          '</div>' +
          '<span class="prod__price">\u00a3' + primerCost.toFixed(2) + '</span>' +
        '</div>';
    }

    var totalCost = tins * paintPrice + primerCost;

    var brkText;
    if (state.mWhat === 'building' && state.mMethod === 'estimate') {
      brkText = 'Estimated ' + area + 'm\u00b2 with 2 coats on ' + sl + ' masonry.';
    } else {
      brkText = area.toFixed(1) + 'm\u00b2 at ' + mPerTin[state.mSurf] + 'm\u00b2 per ' + tinSize + ' tin (2 coats) = ' + tins + ' ' + (tins === 1 ? 'tin' : 'tins') + '.';
    }
    if (state.mBare) brkText += ' Includes stabilising primer for bare surfaces.';

    /* Issue 7: Small job note for 2.5L recommendation */
    var smallJobNote = '';
    if (isSmallJob) {
      smallJobNote = '<div class="res__smalljob">A 2.5L tin is perfect for smaller areas like this.</div>';
    }

    scr.innerHTML =
      '<div class="res__card">' +
        '<p class="res__hl">Your order*</p>' +
        '<p class="res__det">' + desc + ' on ' + sl + ' masonry with 2 coats.</p>' +
        '<div class="prod">' +
          prodImg(calcData.product.image, calcData.product.title) +
          '<div class="prod__body"><span class="prod__name">' + calcData.product.title + '</span><span class="prod__meta">' + tinSize + ' \u00b7 ' + tins + (tins === 1 ? ' tin' : ' tins') + '</span></div>' +
          '<span class="prod__price">\u00a3' + paintTotal + '</span>' +
        '</div>' +
        primerRow +
        '<div class="res__brk">' + brkText + '</div>' +
        smallJobNote +
        '<button class="res__cta" id="CalcAtc-' + sectionId + '">Add to basket \u00b7 \u00a3' + totalCost.toFixed(2) + '</button>' +
        '<p class="res__note">*This is an estimate. Actual coverage varies with surface, application method, and colour change.</p>' +
      '</div>' +
      '<button class="bar__back" id="CalcResBack-' + sectionId + '" style="margin-top:14px">' + backSvg + 'Start over</button>';

    el('CalcAtc').onclick = function () {
      var items = [{ id: calcData.product.variantId, quantity: tins }];
      if (state.mBare && calcData.primer.available) {
        items.push({ id: calcData.primer.variantId, quantity: tins });
      }
      addToCart(items);
    };
    el('CalcResBack').onclick = function () { start(); };
  }

  /* ═══════════════════════════════════════════════════
     Bootstrap — find all calculator sections on the page
     ═══════════════════════════════════════════════════ */

  function bootstrap() {
    document.querySelectorAll('[data-knp-calc-section]').forEach(function (wrapper) {
      var secId = wrapper.dataset.knpCalcSection;
      init(secId);
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(bootstrap, { timeout: 3000 });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

})();
